<template>
    <div></div>
</template>

<script>
import AboveInfoPanel from './AboveInfoPanel.js';
export default AboveInfoPanel;
</script>
